import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { ApprovalDetailModal } from '@/pages/approvals/approval-detail-modal';
import { ApprovalsMobilePage } from '@/pages/approvals/approvals-mobile-page';
import { ApprovalsPage } from '@/pages/approvals/approvals-page';
import { validateApprovalsSearch } from '@/pages/approvals/mobile/approvals-search';
import { useMobile } from '@/shared/lib/use-mobile';

/**
 * `/approvals?team=&approval=&view=` — the ✨ AI hub's Approvals tab.
 *
 * Desktop: the chosen team's queue with a click-through detail modal.
 * Phone (§6 W5-D): every pending request I can see across my teams, a
 * full-screen detail with Approve / Reject — the human-in-the-loop moment,
 * ≤ 3 taps from the push. `?approval=<id>` deep-links straight to one request
 * on both shells (a push or Inbox link can carry it).
 */
function ApprovalsRoute() {
  const isMobile = useMobile();
  const search = Route.useSearch();
  const navigate = useNavigate();
  if (isMobile) return <ApprovalsMobilePage />;
  return (
    <>
      <ApprovalsPage />
      {search.approval && (
        <ApprovalDetailModal
          approvalId={search.approval}
          onClose={() =>
            void navigate({
              to: '/approvals',
              search: { ...search, approval: undefined },
              replace: true,
            })
          }
        />
      )}
    </>
  );
}

export const Route = createFileRoute('/approvals')({
  validateSearch: validateApprovalsSearch,
  component: ApprovalsRoute,
});
